export const alertTitles = {
  loginFailed: "Logowanie nieudane!",
  registerFailed: "Rejestracja nieudana!",
  codeTooShort: "Niepoprawny kod!",
  noSuchCode: "Nie ma takiego kodu!",
  emailSent: "Potwierdź email",
  wrongCode: "Wpisano niepoprawny kod email.",
  emailServerError: "Wystąpił błąd w naszym serwerze e-mail!",
};

export const alerts = {
  wrongPassword: "Wpisane hasło jest niepoprawne.",
  wrongEmail: "Ten email nie jest zarejestrowany w naszej bazie.",
  differentPasswords: "Wpisane hasła są różne.",
  codeTooShort:
    "Wpisany kod jest za krótki. Prawidłowy kod zawiera dokładnie 24 znaki.",
  noSuchCode:
    "Skontakuj się z pracownikiem wypożyczalni (numer telefonu: +48500600700)",
  emailSent:
    "Wpisz kod otrzymany na swoją skrzynkę email lub kliknij w otrzymany link aby potwierdzić email.",
  wrongCode: "Spróbuj ponownie.",
  emailServerError:
    "Spróbuj ponownie później lub  skontaktuj się z wypożyczalnią",
};

export const sectionLabels = {
  register: "Uzupełnij dane aby utworzyć nowe konto",
  registerWithCode: "Zarejestruj z użyciem kodu z wypożyczalni",
  login: "Masz już konto?",
  firstGoogleLogin:
    "Wygląda na to, że to Twoje pierwsze logowanie przy pomocy Google. Uzupełnij poniższe dane by kontynuować!",
};

export const buttonLabels = {
  login: "Zaloguj",
  register: "Zarejestruj",
  registerWithCode: "Zarejestruj z użyciem kodu",
  proceedWithGoogle: "Kontynuuj z użyciem konta Google",
};
